import type { CityDto, GeoAddressDto } from '@features/cities/api/cities.dto'
import type { CitiesFetchOptions } from '@features/cities/api/citiesApi.types'
import {
  mapCitiesDto,
  mapGeoAddressDto,
} from '@features/cities/api/citiesMapper'
import type { City, GeoAddress } from '@features/cities/types'
import { useNuxtApi } from '@shared/nuxt/useNuxtApi'

export const citiesApi = {
  getList(options?: CitiesFetchOptions<CityDto[], City[]>) {
    return useNuxtApi<CityDto[], City[]>('/api/cities', {
      ...options,
      transform: mapCitiesDto,
    })
  },

  async convertGeoPoint(input: {
    latitude: number
    longitude: number
    radiusMeters?: number
  }): Promise<GeoAddress> {
    const dto = await $fetch<GeoAddressDto>(
      '/api/geo/convert-geo-point-to-address-v1',
      {
        method: 'POST',
        body: {
          geo_point: {
            latitude: input.latitude,
            longitude: input.longitude,
          },
          radius_meters: input.radiusMeters ?? 50,
        },
      },
    )

    return mapGeoAddressDto(dto)
  },
}
